// extracted by mini-css-extract-plugin
module.exports = {"figure":"bn_hs","figure_isMargin":"bn_ht","figure__link":"bn_hv","figure__caption":"bn_hw"};